module.exports = __webpack_public_path__ + "images/emoji/chocolate_bar.fc229a1f1c89c846048c.png";